const weekdays: string[] = [
  "Sonntag",
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
  "Samstag",
];

function fixLeadingZero(date: number): string {
  return `0${date}`.slice(-2);
}

function baseTime(date: Date): string {
  return `${fixLeadingZero(date.getHours())}:${fixLeadingZero(date.getMinutes())}`;
}

export const getFormattedDatetimeString = (timestamp: string, hideDate: boolean): string => {
  const givenDate = new Date(timestamp);

  if (isNaN(givenDate.getTime())) return "";

  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  if (hideDate) {
    return baseTime(givenDate);
  }

  const isToday = givenDate.toDateString() === now.toDateString();
  if (isToday) {
    return baseTime(givenDate);
  }

  const isYesterday = givenDate.toDateString() === yesterday.toDateString();
  if (isYesterday) {
    return `Gestern ${baseTime(givenDate)}`;
  }

  const isWithinWeek = givenDate > new Date(now.setDate(now.getDate() - 6));
  if (isWithinWeek) {
    return `${weekdays[givenDate.getDay()]} ${baseTime(givenDate)}`;
  }

  return `${fixLeadingZero(givenDate.getDate())}.${fixLeadingZero(givenDate.getMonth() + 1)}.${givenDate.getFullYear()} ${baseTime(givenDate)}`;
};
